/*
 * @Author: huajian
 * @Date: 2023-10-31 18:38:31
 * @LastEditors: yusha
 * @LastEditTime: 2024-06-06 13:24:21
 * @Description: 枚举中心
 */

/** 转化为code为键值 */
export const setCodeKey = (enumObj: {
	[key: string]: {
		code: number;
		cn: string;
	};
}) => {
	Object.keys(enumObj).forEach((key) => {
		enumObj[enumObj[key].code] = enumObj[key];
	});
};
export const EnumStationList = {
	JAPAN: 'JapanStation',
	KOREA: 'KoreaStation'
} as const;

/** 系统类型 1-D2C; 2-B2B （后端字段 system_source） */
export enum ENUM_SYSTEM_SOURCE {
	/** D2C */
	D2C = 1,
	/** B2B */
	B2B = 2
}
